export const headerDataState = {
    title: 'Etats personnalisés',
    submodules: [
        
    ],
}
function createData(id, moduleName, ref) {
    return { id, moduleName, ref };
}